export class CampusIQError extends Error {
    public readonly statusCode: number;
    public readonly code: string;
    public readonly requestId?: string;

    constructor(
        message: string,
        statusCode: number = 500,
        code: string = 'UNKNOWN_ERROR',
        requestId?: string
    ) {
        super(message);
        this.name = 'CampusIQError';
        this.statusCode = statusCode;
        this.code = code;
        this.requestId = requestId;

        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, CampusIQError);
        }
    }

    public toJSON(): Record<string, any> {
        return {
            name: this.name,
            message: this.message,
            statusCode: this.statusCode,
            code: this.code,
            requestId: this.requestId,
            stack: this.stack
        };
    }

    public static isNetworkError(error: any): boolean {
        return error instanceof CampusIQError && error.code === 'NETWORK_ERROR';
    }

    public static isAuthenticationError(error: any): boolean {
        return error instanceof CampusIQError && error.statusCode === 401;
    }

    public static isAuthorizationError(error: any): boolean {
        return error instanceof CampusIQError && error.statusCode === 403;
    }

    public static isNotFoundError(error: any): boolean {
        return error instanceof CampusIQError && error.statusCode === 404;
    }

    public static isRateLimitError(error: any): boolean {
        return error instanceof CampusIQError && error.statusCode === 429;
    }

    public static isServerError(error: any): boolean {
        return error instanceof CampusIQError && error.statusCode >= 500;
    }
}
